import { defineBlock } from "eddev/blocks"
import { Swiper, SwiperSlide } from "@components/atoms/Swiper"
import { EditableText } from "eddev/blocks"
import { ManualCards } from "@components/molecules/Cards"
import { Button } from "@components/atoms/Button"

export const meta: BlockMeta = {
  title: "Multi card container",
  category: "common",
  icon: "format-gallery",
  keywords: ["card"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("general/card-multi", (props) => {
  return (
    <div className="grid-auto gap-6 my-7">
      <div className="col-span-12 md:col-span-10 md:col-start-2 lg:col-span-8 lg:col-start-3">
        <EditableText as="h4" className="md:!text-center" store="title" placeholder="Enter title..." />
      </div>
      <div className="col-span-12">
        {props.cards && (
          <>
            <style
              dangerouslySetInnerHTML={{
                __html: `
                .card-multi-swiper {
                  overflow: visible !important;
                  padding-bottom: 40px;

                  div[class^='swiper-button'] {
                    top: auto;
                    bottom: -10px;
                    right: 0;
                    left: auto;
                    width: 32px;
                    height: 32px;
                    color: #222222;
                    box-shadow: inset 0px 0px 0px 1px #222222;
                    border-radius: 6px;
                    transition: all .35s cubic-bezier(.19,1,.22,1);

                    &:after {
                      font-size: 16px !important;
                    }
                      
                    svg {
                      width: 5px;
                      height: auto;

                      path {
                        stroke: currentColor;
                        stroke-width: 2px;
                      }
                    }

                    &:hover {
                      background: #5E5E5E;
                      box-shadow: inset 0px 0px 0px 1px #5E5E5E;
                      color: #FFFFFF;
                    }

                    &:active {
                      background: #222222;
                      box-shadow: inset 0px 0px 0px 1px #222222;
                      color: #FFFFFF;
                    }

                    &:disabled {
                      background: transparent;
                      box-shadow: inset 0px 0px 0px 1px #8E8E8E;
                      color: #8E8E8E;
                    }
                  }

                  .swiper-button-prev {
                    margin-right: 50px;
                  }
                }

                @media only screen and (min-width: 900px) {
                  .card-multi-swiper {
                    padding-bottom: 0;

                    div[class^='swiper-button'] {
                     bottom: -65px;
                    }
                  }
                }

                @media only screen and (min-width: 1200px) {
                  .card-multi-swiper {
                    div[class^='swiper-button'] {
                      bottom: -85px;
                    }
                  }
                }
              `,
              }}
            />
            <Swiper
              className="card-multi-swiper"
              spaceBetween={24}
              autoplay={{
                delay: 5000,
              }}
              navigation
              breakpoints={{
                1200: {
                  slidesPerView: 3,
                },
                900: {
                  slidesPerView: 2.25,
                },
                0: {
                  slidesPerView: 1.15,
                },
              }}
            >
              {props.cards.map((card, i) => (
                <SwiperSlide key={i} style={{ display: "flex", height: "auto" }}>
                  <ManualCards
                    type="multi"
                    title={card?.title ?? undefined}
                    content={card?.content ?? undefined}
                    chip={{
                      color: "grey",
                      children: card?.chipText ?? undefined,
                    }}
                    image={card?.image ?? undefined}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </>
        )}
      </div>
      {props.button && (
        <div className="col-span-12">
          <div className="w-full flex items-center justify-start md:justify-center md:mt-7">
            <Button
              color="yellow"
              size="medium"
              href={props.button?.url ?? undefined}
              target={props.button.target ? "_blank" : undefined}
              icon="ARROW_RIGHT"
              iconStyle="right"
            >
              {props.button.title}
            </Button>
          </div>
        </div>
      )}
    </div>
  )
})
